export const CHALLENGE_IFRAME_ID = 'ovh_security_challenge';
export const TTL_TO_WAIT_IFRAME_RESPONSE = 1000;
export const INVISIBLE_CHALLENGE_ERROR_CLASS = 'Client::BadRequest::ChallengeRequired';
export const IFRAME_STYLE = 'position: absolute; width:0; height:0; border:0;';
